module.exports = __webpack_public_path__ + "static/media/bytt-no-2.24477f98.mp3";